import { SYNC_KEY_PROYECTOS_CULTIVOS } from "../../../constantes";
import { ProyectosPlataformaService } from "../../../shared/generated/grpc/plataforma_proyectos_pb";
import { CultivoResponse } from "../../../shared/response/proyectos/CultivoResponse";
import { ServiceGetListBase } from "../../../shared/services/base/ServiceGetListBase";
import { grpcCall, grpcClient } from "../../../shared/services/grpc/grpcCall";

/** Cultivos de proyecto (`ListCultivos`, gRPC): listado en memoria. */
export class CultivoService extends ServiceGetListBase<CultivoResponse> {
  static readonly instance = new CultivoService();
  private constructor() { super(); }

  /** Clave única del listado: deduplica `sync()` (dos pedidos simultáneos, un solo request). */
  protected readonly syncKey = SYNC_KEY_PROYECTOS_CULTIVOS;

  /** gRPC-Web (`ListCultivos`): no eliminados, por nombre. */
  protected async fetchItems(): Promise<CultivoResponse[]> {
    const r = await grpcCall(() => grpcClient(ProyectosPlataformaService).listCultivos({}));
    return r.items.map((c) => ({ id: c.id, isEliminado: false, nombre: c.nombre, slug: c.slug, mesesACosecha: c.mesesACosecha }));
  }
}
